import { Box } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';

import { Chip } from '../Chip';

const fillBreathe = keyframes`
  0%, 100% { opacity: .75; }
  50% { opacity: 1; }
`;

/** Активная сессия: компактный статус, одинаковый в карточке, чате и комнате. */
export const LiveBadge = () => (
  <Chip
    variant="status"
    size="sm"
    colorPalette="green"
    textStyle="micro"
    w="fit-content"
    h={5}
    px={2}
    py={0}
    gap={1}
    position="relative"
    isolation="isolate"
    bgColor="transparent"
    color="status.live.fg"
    _before={{
      content: '""',
      position: 'absolute',
      inset: 0,
      borderRadius: 'inherit',
      bgColor: 'status.live.bg',
      zIndex: -1,
      animation: `${fillBreathe} var(--chakra-durations-ambient) var(--chakra-easings-ease-in-out) infinite`,
    }}
    css={{
      '@media (prefers-reduced-motion: reduce)': {
        '&::before': { animation: 'none', opacity: 1 },
      },
    }}
  >
    <Box
      as="span"
      boxSize={1}
      flexShrink={0}
      borderRadius="full"
      bgColor="status.live.solid"
      aria-hidden="true"
    />
    LIVE
  </Chip>
);
